<script setup lang="ts">
import {ref} from "vue";
import {Upload} from "@/types";
import {useGpg} from "@/composables/gpg";
import {router} from "@inertiajs/vue3";
import {route} from "ziggy-js";

interface Props {
  upload: Upload
}
const props = defineProps<Props>()

const { formatFingerprint } = useGpg()

const isDialogOpen = ref(false)
</script>

<template>
    <v-dialog
        v-model="isDialogOpen"
        max-width="500"
    >
        <template #activator="{ props: attrs }">
            <default-btn
                v-bind="attrs"
                variant="plain"
                :rounded="true"
                class="font-weight-medium border bg-transparent"
                icon="mdi-code-tags"
                size="small"
            >
                <v-icon
                    color="primary"
                >
                    mdi-code-tags
                </v-icon>
            </default-btn>
        </template>

        <v-card
            :flat="true"
            rounded="lg"
            class="border"
        >
            <v-card-title class="font-weight-bold border-bottom text-body-2 bg-grey-lighten-4 border-b">
                Transfer metadata
                <v-btn
                    variant="plain"
                    size="x-small"
                    icon="mdi-close"
                    class="float-end"
                    @click="isDialogOpen = false"
                />
            </v-card-title>

            <v-card-text class="pt-5 black--text">
                <dt class="text-body-2 font-weight-bold">
                    Project
                </dt>
                <dd
                    class="text-body-2 underline-hover"
                    @click="router.visit(route('projects.show', {project: props.upload.project_slug}))"
                >
                    {{ props.upload.project }}
                </dd>
                <dt class="text-body-2 font-weight-bold mt-3">
                    User
                </dt>
                <dd
                    class="text-body-2 underline-hover"
                    @click="router.visit(route('users.show', {user: props.upload.user}))"
                >
                    {{ props.upload.user }}
                </dd>
                <dt class="text-body-2 font-weight-bold mt-3">
                    Recipients
                </dt>
                <dd class="text-body-2">
                    <div
                        v-for="(recipient) in JSON.parse(props.upload.recipients)"
                        :key="recipient"
                    >
                        {{ formatFingerprint(recipient) }}
                    </div>
                </dd>
                <dt class="text-body-2 font-weight-bold mt-3">
                    Timestamp
                </dt>
                <dd class="text-body-2">
                    {{ props.upload.timestamp }}
                </dd>
                <dt class="text-body-2 font-weight-bold mt-3">
                    Checksum
                </dt>
                <dd class="text-body-2">
                    {{ props.upload.checksum }}
                </dd>
                <dt class="text-body-2 font-weight-bold mt-3">
                    Checksum algorithm
                </dt>
                <dd class="text-body-2">
                    {{ props.upload.checksum_algorithm }}
                </dd>

                <dt class="text-body-2 font-weight-bold mt-3">
                    Compression algorithm
                </dt>
                <dd class="text-body-2">
                    {{ props.upload.compression_algorithm }}
                </dd>
                <dt class="text-body-2 font-weight-bold mt-3">
                    Version
                </dt>
                <dd class="text-body-2">
                    {{ props.upload.version }}
                </dd>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<style scoped>
.underline-hover:hover {
    text-decoration: underline;
    cursor: pointer;
}
</style>
